module.exports = __webpack_public_path__ + "img/wildwood-logo@2x.a642452f.png";